import { Navigate, createBrowserRouter } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import ScrollToTop from 'ui-component/ScrollToTop';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
  {
    ...MainRoutes,
    element: (
      <>
        <ScrollToTop />
        {MainRoutes.element}
      </>
    ),
  },
]);

export default router;
